import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const ChallengeWrapper = styled.div<{
  small?: boolean;
  upvotedByUser: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-top: ${({ small }) => (small ? '12px' : '24px')};
  border-radius: 5px;
`;

export const ChallengeInfoWrapper = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  font-weight: ${themeStyle.fontBold};
`;

export const ChallengePositionInfo = styled.div`
  font-weight: ${themeStyle.fontSemiBold};
  font-size: ${themeStyle.fontSize14};
  background-color: ${themeStyle.varInkSuperLight};
  color: ${themeStyle.varInkMain};
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  height: 40px;
  width: 100%;
  max-width: 298px;
  ${QUERIES.laptopAndUp} {
    width: 289px;
    max-width: unset;
  }
  padding: 12px;
  gap: 10px;
  border-radius: 5px;
`;
